// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__qkZEF","info":"Note_info__27cz-","note":"Note_note__F7Wej","actions":"Note_actions__BlhsK"};